import * as React from "react"
import { MessageCarousel } from "./MessageCarousel.js"
import { MainProps, PROMOBAR_SKINS } from "./types.js"

export const Root: React.FC<MainProps> = ({ data, pageType }) => {
  if (!data) {
    return null
  }
  if (pageType && data.excludedPageTypes.includes(pageType)) {
    return null
  }
  return <MessageCarousel data={data} pageType={pageType ?? ""} />
}
